__turbopack_context__.v({
  "className": "firstrunserif_c4e902da-module__PpIX1G__className",
  "variable": "firstrunserif_c4e902da-module__PpIX1G__variable",
});
